<template>
	<div
		ref="listRef"
		class="relative flex items-center w-full md:w-[calc(20%-20px)] min-h-[56px] pl-0 sm:pl-4 md:pl-6 pr-0 sm:pr-4 pb-2 md:pb-0 md:mt-0 mt-3 border-b-[1px] border-gray-light md:border-0"
	>
		<div @click="showList = !showList" class="flex flex-col w-[calc(100%-30px)] cursor-pointer">
			<span class="pb-1 text-dj-gray-dark text-sm font-medium">{{ $t("companies.searchbar.size.title") }}</span>
			<span
				v-if="selectedSizes.length"
				class="block overflow-hidden overflow-ellipsis whitespace-nowrap w-[calc(100%-6px)] cursor-default"
			>
				{{
					selectedSizes
						.map((l) => l.name)
						.map((n) => n[locale])
						.join(", ")
				}}
			</span>
			<span v-else class="text-dj-gray">{{ placeholder }}</span>
		</div>

		<DropdownButton v-model="showList" class="mt-2" />

		<div
			v-show="showList"
			class="absolute p-5 left-0 md:-left-8 top-[60px] md:top-[85px] w-[400px] max-w-[100%] md:max-w-[100vw] max-h-[350px] bg-white border border-dj-gray-light rounded-big flex flex-col z-30"
		>
			<div class="flex flex-col gap-y-[10px] overflow-auto">
				<BaseCheckbox
					v-for="(size, index) in sizesWithValue"
					:key="index"
					v-model="size.value"
					@change="onChange($event, size)"
				>
					{{ size.name[locale] }}
				</BaseCheckbox>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent, ref, type PropType } from "vue";
import { onClickOutside, useFocus } from "@vueuse/core";
import { useI18n } from "vue-i18n";
import axios from "axios";

export default defineComponent({
	name: "SearchbarCompaniesSize",
	props: {
		modelValue: {
			type: Array as PropType<string[]>,
			required: true,
		},
		filterList: {
			type: Array as PropType<string[]>,
			default: [],
		},
		placeholder: {
			type: String,
			default: "",
		},
	},
	emits: ["update:modelValue"],
	async setup(props, { emit }) {
		const { locale } = useI18n();

		const inputRef = ref(null);
		const listRef = ref(null);

		const inputVmodel = ref("");

		const sizeData = ref();
		const sizesWithValue = ref([]);
		const selectedSizes = ref<string[]>([]);

		const showList = ref(false);

		if (props.filterList.length > 0) {
			sizeData.value = props.filterList;
			setDataArrays();
		} else {
			// Fallback API
			await axios(globalConfig.API + "/tags?type[]=company-size&limit=-1").then((response) => {
				sizeData.value = response.data.data;
				setDataArrays();
			});
		}

		function transformArray() {
			return sizeData.value.map((size) => {
				return {
					...size,
					value: false,
				};
			});
		}

		function setDataArrays() {
			sizesWithValue.value = transformArray();
		}

		const { focused: inputFocus } = useFocus(inputRef);

		onClickOutside(listRef, () => {
			showList.value = false;
			inputVmodel.value = "";
		});

		onMounted(() => {
			// get locations ID from url & set selectedlocations
			const query = useRoute().query;
			if (query.companysize) {
				const queryCompanySize = query.companysize.toString().split(",");
				queryCompanySize.forEach((ql) => {
					const num = Number.parseInt(ql);

					const targetIndex = sizesWithValue.value.findIndex((pred) => pred.id == num);
					if (targetIndex > -1) {
						sizesWithValue.value[targetIndex].value = true;
						selectedSizes.value.push(sizesWithValue.value[targetIndex]);
					}
				});
				emit("update:modelValue", selectedSizes.value);
			}
		});

		function onChange(event, settlement: string) {
			event
				? selectedSizes.value.push(settlement)
				: selectedSizes.value.splice(selectedSizes.value.indexOf(settlement), 1);
			emit("update:modelValue", selectedSizes.value);
		}

		return {
			inputRef,
			inputVmodel,
			inputFocus,
			listRef,
			showList,
			sizesWithValue,
			onChange,
			selectedSizes,
			locale,
		};
	},
});
</script>
